export default __webpack_public_path__ + "static/media/mouse.3e14b180.webp";